﻿window.cObjetBcDossierMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "dossier"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouveau dossier"; }
    this.mGetLib1 = function (option) {
        if (typeof objet.data != 'undefined') { return ((objet.data.objet) ? objet.data.objet : "(aucun nom)") }
        else {
            var txt = "dossier"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-folder-closed' title='Dossier'></i>");
    }
    this.contentTemplatePopup = function (contentElement, option) {
        $("<div/>").appendTo(contentElement).dxCtrlDossierUpdateBc({
            bddCtrl: Me.objet.bddRef,
            data: objet.data
        })
    }

    this.mGetDossierParent = function () {
        if (objet.data.id_bc_dossier_parent == null) { return null }
        else { return Me.objet.bddRef.getObjet("bc_dossier", objet.data.id_bc_dossier_parent).data }
    }

    this.mGetDossierEnfant = function () {
        return Me.objet.bddRef.mGetArray("bc_dossier").filter(function (o) { return o.id_bc_dossier_parent == objet.data.id_bc_dossier })
    }
    this.mGetArticleEnfant = function () {
        return Me.objet.bddRef.mGetArray("bc_article").filter(function (o) { return o.id_bc_dossier_parent == objet.data.id_bc_dossier })
    }

    this.mGetLstParent = function () {
        var lst = []
        var eleEnCours = objet.data
        while (eleEnCours != null) {
            lst.unshift(eleEnCours)
            eleEnCours = Me.objet.bddRef.getObjet(eleEnCours).objetMetier.mGetDossierParent()
        }
        return lst
    }

    this.mGetNbArticle = function () {
        var nb = this.mGetArticleEnfant().length
        this.mGetDossierEnfant().forEach(function (dossier) {
            nb += Me.objet.bddRef.getObjet(dossier).objetMetier.mGetNbArticle()
        })
        return nb
    }
    this.mGetNbDossier = function () {
        var nb = this.mGetDossierEnfant().length
        this.mGetDossierEnfant().forEach(function (dossier) {
            nb += Me.objet.bddRef.getObjet(dossier).objetMetier.mGetDossierEnfant().length
        })
        return nb
    }

    this.mGetLink = function (appli) {
        //if (typeof appli == "undefined" || appli == null) appli = gestCognoss.mGetAppliCourante()
        //return appli.urlcognoss + "/" + appli.code_appli + "/" + objet.data.id_bc_dossier + "/0/" + replaceEncodableChars(objet.data.objet) + "/bc"
        ////return appli.urlcognoss + "/" + objet.data.id_bc_dossier + "/0/bc"

        if (typeof appli == "undefined" || appli == null) appli = gestCognoss.mGetAppliCourante()
        if (parametre.isLocalhost) {
            return appli.urlcognoss + "/" + objet.data.id_bc_dossier + "/0/" + replaceEncodableChars(objet.data.objet) + "/bc"
            //return appli.urlcognoss + "/0/" + objet.data.id_bc_article + "/bc"
        } else {
            return appli.urlcognoss + "/" + appli.code_appli + "/" + objet.data.id_bc_dossier + "/0/" + replaceEncodableChars(objet.data.objet) + "/bc"
            //return appli.urlcognoss + "/0/" + objet.data.id_bc_article + "/bc"
        }
    }

    this.mGetElementLink = function (appli) {
        if (typeof appli == "undefined") appli = gestCognoss.mGetAppliCourante()
        var $SpanLink = $("<span></span>")
        var $i = $("<i class='fas fa-copy state-hover'></i>").appendTo($SpanLink)
        $i.attr("title","Cliquer pour copier l'adresse dans le presse-papier")
        var $u = $("<u style='padding-left:5px;'>" + this.mGetLink(appli).reduit(24) + "</u>").appendTo($SpanLink)
        $u.attr("title", this.mGetLink(appli))
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $i, position: "bottom", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>Cliquer pour copier l'adresse dans le presse-papier</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        $i.on("click", function (e) {
            e.stopPropagation()
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(Me.mGetLink(appli)).select();
            document.execCommand("copy");
            $temp.remove();
            mNotify("L'adresse du dossier a été copiée dans le presse-papier", "success", 6000)
        })
        return $SpanLink
    }

    this.mGetLstAppli = function () {
        return gestCognoss.dsAppli.filter(function (o) {
            if (typeof o.bcAppli != 'undefined') {
                return Me.objet.bddRef.mGetArray("bc_dossier_bc_appli").filter(function (dossApp) {
                    return dossApp.id_bc_dossier == objet.data.id_bc_dossier && o.bcAppli.id_bc_appli == dossApp.id_bc_appli
                }).length > 0
            } else { return false }
        })   
    }

    this.mGetWidthPopup = function () { return 500 }
    this.mGetPaddingPopup = function () { return 20 }

    this.isPopupFullScreen = true
    //this.mShowPopup = function (optionPopup) {
    //    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
    //        position: {
    //            my: "right top",
    //            at: "right top",
    //            of: "body"
    //        },
    //        width: 600,
    //        height: "100%",
    //        showTitle: true,
    //        showMaximize: false,
    //        title: "Dossier",
    //        contentTemplate: function (contentElement) {
    //            Me.contentTemplatePopup(contentElement)
    //        },
    //        onHidden: optionPopup.onHidden
    //    }).dxCtrlPopupBase("instance")
    //    popup.show();
    //}

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "400",
            maxWidth: "calc(100% - 60px)",
            height: "600",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right bottom",
                at: "right bottom",
                of: "body",
                offset: { x: -50, y: -25 }
            }
        }
    }
    this.mGetDisplayInPopup = function (newValue) {
        return true
    }

}